"use client";

import {
  useParams,
  type useRouter,
  type useSearchParams,
} from "next/navigation";

export function useRouteParams<T extends Record<string, any>>(): T {
  return useParams();
}

export function getQueryString(
  searchParams: ReturnType<typeof useSearchParams>,
  params: Record<string, any>
) {
  const newSearchParams = new URLSearchParams(searchParams);
  for (const key in params) {
    newSearchParams.set(key, params[key]);
  }

  return newSearchParams.toString();
}

export function replaceSearchParams(
  router: ReturnType<typeof useRouter>,
  searchParams: ReturnType<typeof useSearchParams>,
  params: Record<string, any>
) {
  const newQuery = getQueryString(searchParams, params);
  router.replace(`?${newQuery}`);
}

export function useReplaceSearchParams(
  router: ReturnType<typeof useRouter>,
  searchParams: ReturnType<typeof useSearchParams>
) {
  return (params: Record<string, any>) =>
    replaceSearchParams(router, searchParams, params);
}
